<template>
<div class="m-t-30 m-b-30">
  <section class="search-section">

    <div class="row normal-mode" v-if="mode=='Normal Mode'">
      <div class="col-3">
        <b-form-select v-model="selected" :options="stores" @change="storeWiseSearch('store selector')"></b-form-select>
      </div>

      <div class="col-3">
        <b-form-select v-model="statusSelected" :options="storeStatuses" @change="storeWiseSearch" :disabled="!specificSearchActive"></b-form-select>

      </div>

      <div class="col-4">
        <b-form-input list="my-list-id" v-model="searchTerm" class="d2d-inputs" placeholder="Specific Search" :disabled="!specificSearchActive" @change="storeWiseSearch"></b-form-input>

        <datalist id="my-list-id">
          <option v-for="(column, index) in columns" v-bind:key="index">{{ column }}</option>
        </datalist>
      </div>

      <div class="col-2">
        <div class="row">
          <div class="col-sm-12">
            <b-form-select v-model="selectedItemCount" :options="perPageCount" @change="orderPerPageChanged"></b-form-select>
          </div>
        </div>
      </div>

      <div class="col-10">
          <b-form-group label="Filter by extra options " class="m-t-20" v-if="extraStatusesOptions.length > 0">
            <b-form-checkbox-group @input="storeWiseSearch" size="sm" v-model="extraStatusesSelected" :options="extraStatusesOptions" switches></b-form-checkbox-group>
          </b-form-group>
        </div>

      <div class="col-2">
        <b-link href="#foo" class="m-t-10 advanced-filter-opener float-right" @click.prevent="showAdvancedFilter = !showAdvancedFilter"><i class="fa fa-filter" aria-hidden="true"></i> Advanced Filter</b-link>
      </div>
    </div>

    <div class="list-mode" v-if="mode=='List Mode'">
      <list-mode /> 
    </div>
    
    <orders-advanced-filter :show-filter="showAdvancedFilter" />
  </section>
</div>
</template>

<script>
import StoreService from '../../services/store.service';
import OrderStatusesService from '../../services/order-statuses.service';

import EventBus from '../../EventBus';
const OrdersAdvancedFilter = () => import( /* webpackChunkName: "orders.orders-advanced-filter" */ './orders-advanced-filter');
const ListMode = () => import(/* webpackChunkName: "list.list-mode" */ "./list/list-mode")
export default {
  data() {
    return {
      mode: 'Normal Mode',
      selected: null,
      selectedItemCount: 25,
      specificSearchActive: false,
      stores: [{
        value: null,
        text: 'Select a store'
      }],
      perPageCount: [{
          value: 10,
          text: '10'
        },
        {
          value: 25,
          text: '25'
        },
        {
          value: 50,
          text: '50'
        },
        {
          value: 75,
          text: '75'
        },
        {
          value: 100,
          text: '100'
        },
      ],
      showAdvancedFilter: false,
      columns: ['[Tags]', '[Fulfillment Status]', '[Order No]', '[Item Name]', '[Customer Email]', '[Customer Name]'], // '[Country Code]'
      searchTerm: "",
      statusSelected: null,
      storeStatuses: [],
      extraStatusesOptions: [],
      extraStatusesSelected: []
    }
  },
  mounted() {
    this.fetchStores();

    EventBus.$on("extra-statuses-fetched", extraStatuses => {
      this.extraStatusesOptions = extraStatuses.map(status => {
        return {
          text: status.name,
          value: status.id
        }
      });
      this.extraStatusesSelected= []
    })

    EventBus.$on("record-mode-changed",  mode => this.mode = mode)

    // Orders list related 
    EventBus.$on("load-list-data", () => {
       console.log("orders-filter : load list data event")
       this.resetForm()
    })

    EventBus.$on("exited-list", () => {
       this.resetForm()
    })

  },
  components: {
    OrdersAdvancedFilter,
    ListMode
  },
  methods: {
    resetForm(){
        this.selected= null;
        this.searchTerm= "";
        this.statusSelected = null;
        this.storeStatuses = [];
        this.extraStatusesOptions = [];
        this.extraStatusesSelected = [];
    },
    fetchStores() {

      StoreService.fetchStores().then(response => {
          let company_stores = response.data.data.map(store => {
            return JSON.parse(JSON.stringify({
              value: store.id,
              text: store.identifier
            }))
          });
          this.stores = this.stores.concat(company_stores);
        })
        .catch(errors => console.log(errors));
    },
    async fetchStoreStatuses(storeId) {

      const result = await OrderStatusesService.fetchStoreWiseStatusList(storeId);

      const statusesList = result.data.statusList.map(status => {
        return {
          text: status.title,
          value: status.id
        }
      })

      this.storeStatuses = [{
          value: null,
          text: 'Select a status'
        },
        ...statusesList
      ];
    },
    storeWiseSearch(selectorType = 'Others') {

      let data = {}
      data.store_id = this.selected;

      if (selectorType == 'store selector') {
        this.fetchStoreStatuses(this.selected);
        this.$store.dispatch('status/removePreferredStatus');
        EventBus.$emit('store-selected-or-changed', this.selected);
      }

      // add search term to search;
      data.searchTerm = this.searchTerm ? this.searchTerm : null;

      // add status to data obj if it's there.
      data.statusSelected = this.statusSelected ? this.statusSelected : null;

      data.extraStatuses = this.extraStatusesSelected;

      if (this.selected) {
        this.specificSearchActive = true;
      } else {
        this.specificSearchActive = false;
      }

 
    
      EventBus.$emit('search-term-order-search', data);

    },
    extraStatusUpdated(){
        console.log(this.extraStatusesSelected)
    },
    orderPerPageChanged() {
      EventBus.$emit('order-per-page-changed', this.selectedItemCount);
    }
  },
  beforeDestroy() {
    EventBus.$off("extra-statuses-fetched")
    EventBus.$off("load-list-data")
    EventBus.$off("exited-list")
  },
}
</script>

<style lang="scss" scoped>

.search-section {
  padding: 20px;
  background-color: #EDF4F7;
  border: 1px solid #d3eaf5;
  color: #304149;
  border-radius: 5px;
}

.advanced-filter-opener {
  display: inline-block;
  font-size: 13px;
  color: rgb(83, 83, 83);
  text-decoration: none;

  &:hover {
    color: rgb(143, 143, 143);
  }
}
</style>
